import React from "react";
import standardInputWrapper from "../../standard-input-wrapper/standard-input";
import FormTextarea from "../../../form/textarea/form-textarea";

const SCAT5InputTextarea = standardInputWrapper(FormTextarea);

export default SCAT5InputTextarea;
